import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import TopNavigation from '../../components/TopNavigation';
import Button from '../../components/ui/Button';
import Footer from '../../components/Footer';

const Careers = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Careers - Sleeve</title>
        <meta
          name="description"
          content="Join the Sleeve team. Career opportunities coming soon."
        />
      </Helmet>

      <TopNavigation />

      <main className="min-h-screen bg-background flex items-center justify-center px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="text-2xl font-bold text-foreground mb-4 md:mb-6">
            Careers
          </h1>
          <p className="text-base md:text-lg text-muted-foreground mb-8 md:mb-10">
            Coming soon
          </p>
          <Button
            variant="outline"
            size="lg"
            iconName="ArrowLeft"
            iconPosition="left"
            onClick={() => navigate('/about')}
          >
            Back to About
          </Button>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Careers;